module.exports = __webpack_public_path__ + "static/pA0-5a60044a967f9fcc00faa3df986c9239.png";